import { createContext } from 'react';
import { SubMenu } from 'shared/components/connected/task-card-multi-select-context-menu';
import { Task } from 'shared/types/task';

export type Payload = { tasks: Task[]; initialActiveSubMenu?: SubMenu };
export type Position = { left: number; top: number };

type ContextMenuContextType = {
  payload?: Payload;
  position?: Position;
  open: (position?: Position, payload?: Payload) => void;
  close: () => void;
};

export const ContextMenuContext = createContext<ContextMenuContextType>({
  payload: undefined,
  position: undefined,
  open: () => {},
  close: () => {},
});
